import { project } from './initializeStats';
import { getIndex } from './helpers';

export function sendStats(category, action, label, value) {
	if (value) {
		try {
			WP.stat.show(
				wp_sn,
				{
					category,
					label,
					value,
					asproduct,
					asorderid,
					asname,
				},
				action,
			);
		} catch (e) {
			console.log(`stat.show ERROR: ${e}`);
		}
	} else {
		try {
			WP.stat.show(
				wp_sn,
				{
					category,
					label,
					asproduct,
					asorderid,
					asname,
				},
				action,
			);
		} catch (e) {
			console.log(`stat.show ERROR: ${e}`);
		}
	}
}

export function linkStats() {
	const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';

	document.addEventListener('click', function (e) {
		// Sprawdzenie czy kliknięty element lub jego parent ma data-ga360-click
		const el = e.target.closest('[data-ga360-click]');
		if (!el) return;

		const rawData = el.getAttribute('data-ga360-click');
		console.log('GA360 Click:', rawData);

		let eventData = {};

		try {
			// Spróbuj sparsować jako JSON (obsługuj zarówno " jak i ', klucze bez cudzysłowów)
			const normalizedData = rawData.replace(/'/g, '"').replace(/(\w+)\s*:/g, '"$1":');
			eventData = JSON.parse(normalizedData);
		} catch (err) {
			// Jeśli nie JSON, traktuj jako string
			const dataType = rawData;
			eventData.event = 'site_interaction';

			if (dataType === 'customer_logo') {   //ify pod specyfikę serwisu na prośbę klienta - niemcy północne
				eventData.eventCategory = 'customer_logo';
				eventData.eventLabel = el.closest('.header') ? 'header' : el.closest('.footer') ? 'footer' : undefined;
			} else if (dataType === 'wp_logo' || dataType === 'logo_wp') {
				eventData.eventCategory = 'wp_logo';
				eventData.eventLabel = el.closest('.header') ? 'header' : el.closest('.footer') ? 'footer' : undefined;
			} else if (dataType === 'cross_link') {
				eventData.eventCategory = 'customer_link';
				// Bez label
			}
			else if (dataType === 'quiz_link') {
				eventData.eventCategory = 'quiz_banner';
				eventData.eventLabel = 'quiz_link';
				// Bez label
			}
			else if (dataType === 'video_teaser') {
				eventData.event = 'site_interaction'
				eventData.eventCategory = 'video_teaser';
			}
			else if (dataType === 'navigation') {
				eventData.eventCategory = 'navigation';
				// Bez label
			}			
			else {
				console.log('%c zły format w data-ga360-click ', 'background: #f2f2f2; color: #aa2222; border:1px dashed #aa2222');
				return;
			}
		}

		// Wyślij do dataLayer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: eventData.event || 'site_interaction',
			eventCategory: eventData.eventCategory,
			eventAction: eventAction,
			...(eventData.eventLabel && { eventLabel: eventData.eventLabel }),
		});
	});
}

export function shareStats() {
	document.querySelectorAll('.__js_socialShare').forEach((el) => {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			const eventCategory = this.getAttribute('data-id');
			const href = this.getAttribute('data-href');
			const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
			let ga360Socials;
			const eventLabel = window.location.href;
			if (eventCategory === 'facebook') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_FB';
			}
			if (eventCategory === 'instagram') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Instagram';
			}
			if (eventCategory === 'twitter') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Twitter';
			}
			if (eventCategory === 'linkedin') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Linkedin';
			}

			window.dataLayer.push(
				{
					event: 'site_interaction',
					eventCategory: ga360Socials,
					eventAction,
					eventLabel,
				}
			);

			// WP.push(() => {
			//   WP.pwp.customAction({
			//     ga: {
			//       event: 'site_interaction',
			//       eventCategory: ga360Socials,
			//       eventAction,
			//       eventLabel,
			//     },
			//   });
			// });

			sendStats(eventCategory, eventAction, eventLabel);
		});
	});
}

export function setStatElementCollector() {
	document.querySelectorAll('[data-ga360-id]').forEach(function (el) {
		const artId = el.closest('article').getAttribute('data-id');
		const ga360id = el.getAttribute('data-ga360-id');
		if (ga360id === undefined) {
			console.log(
				`%c dodać ga360-id do Galerii hover: ${this.getAttribute('data-id')}`,
				'background: #553311; padding: 3px; color: #ffaaaa',
			);
		} else {
			project.statElementCollector[`${ga360id}-${artId}`] = {
				id: ga360id,
				moduleName: el.getAttribute('data-id'),
				viewedCount: 0,
				itemCount: el.querySelectorAll('.widget__item').length,
			};
		}
		el.statVievedSlide = [];
		project.slidePositionVieved[`${ga360id}-${artId}`] = {};
	});
}

export function statsOnWidgetInteraction(item, arg, idx, evType) {
	const artId = item.closest('article').getAttribute('data-id');
	const ga360id = item.closest('[data-ga360-id]').getAttribute('data-ga360-id');
	const dataId = item.closest('[data-id]').getAttribute('data-id');
	const isClick = !!item.closest('.gallery-slider');
	const hoverEventType = 'ontouchstart' in document.documentElement ? 'tap' : 'hover';

	const itemId = arg;
	if (!ga360id) {
		console.log(
			`%c dodać ga360-id do ${dataId}background: #3b3b3b; padding: 3px; color: #beeb2f`,
		);
	}
	const index = idx || getIndex(item);

	if (!project.isScrollingFlag) {
		project.slidePositionVieved[`${ga360id}-${artId}`][index] = 1;
		project.statElementCollector[`${ga360id}-${artId}`].viewedCount = Object.keys(project.slidePositionVieved[`${ga360id}-${artId}`]).length;
		sendStats(
			'gallery',
			`${isClick && evType ? evType : hoverEventType}-${index}`,
			`${artId} / ${dataId}`,
			itemId,
		);
		window.dataLayer.push({
			event: 'content_interaction',
			eventCategory: ga360id,
			moduleName: dataId,
			eventAction: isClick && evType ? evType : hoverEventType,
		});
	}
}

// PIXEL wph - pixel
wph('track', 'ViewContent', { 'content_name': 'View' });